import { ga } from './ga';
import { vehiclesAPI } from './api';
import { getReferralCode } from './referral';

// Adds utm_source/medium/campaign so GA attributes the visits coming from a shared link (method = whatsapp | copy_link | native | facebook)
export const withUtm = (url, method, campaign) => {
  const u = new URL(url, window.location.origin);
  [...u.searchParams.keys()].filter((k) => k.startsWith('utm_')).forEach((k) => u.searchParams.delete(k));
  u.searchParams.set('utm_source', 'share');
  u.searchParams.set('utm_medium', method);
  u.searchParams.set('utm_campaign', campaign);
  const ref = getReferralCode();
  if (ref) u.searchParams.set('ref', ref); else u.searchParams.delete('ref');
  return u.toString();
};

// GA4 `share` event + anonymous internal counter (independent from the cookie consent)
export const trackShare = (method, kind, { itemId, path, lang, gaParams = {}, ...payload }) => {
  ga.share(method, kind === 'vehicle' ? 'vehicle_selection' : kind, itemId, gaParams);
  vehiclesAPI.trackShare({ kind, method, path, lang, ref: getReferralCode() || undefined, ...payload });
};
